import { MerchantCatalogProduct, VariantsWithPrice } from 'src/app/api/openapi';
import { FormikProps } from 'formik';
import { Box, Button, Stack, Typography } from '@mui/material';
import { AddFromDatabaseFormValues } from './AddProductsFromDatabase';
import { useEffect } from 'react';
import { GridColDef } from '@mui/x-data-grid-premium';
import CustomGridTreeDataGroupingCell from 'src/app/components/CustomGridTreeDataGroupingCell';
import CustomDataGrid from 'src/app/components/CustomDataGrid';

const VerifyPrices = ({
  values,
  setFieldValue,
  submitForm,
  isSubmitting,
}: FormikProps<AddFromDatabaseFormValues>) => {
  const getProductOrVariantName = (
    item: MerchantCatalogProduct | VariantsWithPrice
  ) => {
    if (!item) return '';
    if ('title' in item) return item.title;
    return item.varies_by // @ts-ignore
      ?.map((variable) => variable.value)
      .join(', ');
  };

  useEffect(() => {
    const productsWithPrices: (MerchantCatalogProduct | VariantsWithPrice)[] =
      values.products.reduce(
        (allProducts: any, product) => [
          ...allProducts,
          { ...product, path: [product.id] },
          ...product.variants.map((variant) => ({
            ...variant,
            price: variant.suggested_prices?.length
              ? variant.suggested_prices[0].amount
              : '',
            // @ts-ignore
            path: [product.id, variant.id],
          })),
        ],
        []
      );
    setFieldValue('productsWithPrices', productsWithPrices);
  }, []);

  const columns: GridColDef<MerchantCatalogProduct | VariantsWithPrice>[] = [
    {
      field: 'title',
      headerName: 'Title',
      renderCell: ({ row }) => <>{getProductOrVariantName(row)}</>,
      flex: 1,
    },
    {
      field: 'price',
      headerName: 'Price',
      editable: true,
      width: 150,
    },
    {
      field: 'categories',
      headerName: 'Categories',
      renderCell: ({ row }) =>
        'google_product_category' in row
          ? row.google_product_category?.name
          : '',
      width: 150,
    },
  ];

  const handleAddProducts = () => {
    submitForm()
      .then(() => setFieldValue('activeStep', 2))
      .catch((error) => console.log(error));
  };

  return (
    <Stack mt={2}>
      <Typography variant="h4" gutterBottom>
        Verify that all products have the correct price
      </Typography>
      <CustomDataGrid
        treeData
        getTreeDataPath={(row: any) => row.path}
        rows={values.productsWithPrices}
        columns={columns}
        onCellEditStop={({ id, row, api }) => {
          const index = values.productsWithPrices.findIndex(
            (product) => product.id === row.id
          );
          setFieldValue(
            `productsWithPrices[${index}].price`,
            api.getRowWithUpdatedValues(id, 'price').price
          );
        }}
        groupingColDef={{
          headerName: '',
          renderCell: (params) =>
            //@ts-ignore
            params.row.path.length <= 1 ? (
              <CustomGridTreeDataGroupingCell {...params} />
            ) : null,
          width: 55,
          resizable: false,
        }}
        defaultGroupingExpansionDepth={-1}
      />
      <Box alignSelf="flex-end">
        <Button variant="flat" onClick={handleAddProducts}>
          {isSubmitting ? 'Adding...' : 'Add Products'}
        </Button>
      </Box>
    </Stack>
  );
};

export default VerifyPrices;
